<div class="seneca-list-container">

  <mat-card class="main-container mat-elevation-z2">

    <mat-card-title>
      <h1>Commission Summary</h1>
    </mat-card-title>

    <mat-card-content>
     
      <app-claims-table-submitted></app-claims-table-submitted>

    </mat-card-content>
  </mat-card>

</div>